import { Skeleton, Tab, Tabs } from "@mui/material";
import {
	SaveDraftExteriorTableHeader,
	SaveDraftTableDisclaimer
} from "components/NewOrders/SaveDraft/SaveDraftTable/SaveDraftTable.styles.ts";
import TableSkeleton from "components/Common/Table/TableSkeleton/TableSkeleton.tsx";
import { TableSkeletonWithTabsContainer } from "./TableSkeletonWithTabs.styles.ts";

interface TableSkeletonWithTabsProps {
	tabLabels: string[];
	disclaimerText?: string;
}

const TableSkeletonWithTabs = ({ tabLabels, disclaimerText }: TableSkeletonWithTabsProps) => {
	return (
		<TableSkeletonWithTabsContainer>
			<SaveDraftExteriorTableHeader>
				<Tabs aria-label="Table Skeleton with Tabs">
					{tabLabels.map((label) => (
						<Tab
							key={label}
							label={label}
						/>
					))}
				</Tabs>
			</SaveDraftExteriorTableHeader>

			{disclaimerText && <SaveDraftTableDisclaimer>{disclaimerText}</SaveDraftTableDisclaimer>}
			<Skeleton height={43} />
			<TableSkeleton />
		</TableSkeletonWithTabsContainer>
	);
};

export default TableSkeletonWithTabs;
